// @ts-nocheck
const copyToClipboard = async (text: string) => {
    if (!navigator.clipboard?.writeText) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(text);

        return true;
    } catch {
        return false;
    }
};

export default copyToClipboard;
